// extracted by mini-css-extract-plugin
export var item = "d8_s7";
export var text = "d8_jq";